<template>
  <div class="auto-complete-input-container">
    <mobialis-text-input-with-validation
      :label="label"
      :rules="{ required: true, is: autoCompleteSelectedObjectInnerString }"
      :hiddenLabel="hiddenLabel"
      v-bind="$attrs"
      v-model="autoCompleteInputValInner"
      id="autoComplete"
      class="no-bg-icon"
      vid="autoComplete"
      data-cy="trade-autocomplete-input"
      tabindex="1"
    >
    </mobialis-text-input-with-validation>
  </div>
</template>

<script>
import autoComplete from '@tarekraafat/autocomplete.js';
import { mapState } from 'vuex';
import tradeinService from '../../services/tradeinService';

export default {
  name: 'TradeAutoComplete',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    hiddenLabel: {
      type: Boolean,
      default: false,
    },
    valueObject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      autoCompleteInputValInner: '',
      autoCompleteSelectedObjectInner: {},
    };
  },
  watch: {
    value(newVal) {
      this.autoCompleteInputValInner = newVal;
    },
    valueObject(newVal) {
      this.autoCompleteSelectedObjectInner = newVal;
    },
    autoCompleteSelectedObjectInner(newVal) {
      this.$emit('input', this.autoCompleteInputValInner);
      this.$emit('selectedVehicleObject', newVal);
    },
  },
  created() {
    if (this.value) {
      this.autoCompleteInputValInner = this.value;
    }
    if (this.valueObject) {
      this.autoCompleteSelectedObjectInner = this.valueObject;
    }
  },
  computed: {
    ...mapState('business', ['api']),
    autoCompleteSelectedObjectInnerString() {
      return `${this.autoCompleteSelectedObjectInner.year} ${this.autoCompleteSelectedObjectInner.make} ${this.autoCompleteSelectedObjectInner.model} ${this.autoCompleteSelectedObjectInner.trim} ${this.autoCompleteSelectedObjectInner.style}`;
    },
  },
  mounted() {
    // eslint-disable-next-line no-shadow,new-cap
    const autoCompleteJS = new autoComplete({
      placeHolder: this.placeholder,
      threshold: 3,
      debounce: 200,
      searchEngine: 'loose',
      resultsList: {
        maxResults: undefined,
        noResults: true,
        element: (list, data) => {
          if (!data.results.length) {
            const message = document.createElement('div');
            message.setAttribute('class', 'no-results');
            message.innerHTML = `<span>${this.$t('message.common.noResultsFound', { query: data.query })}</span>`;
            list.appendChild(message);
          }
        },
      },
      data: {
        src: async query => {
          try {
            const { data } = await tradeinService.getAutocomplete(
              encodeURIComponent(query),
              this.api.key,
              this.api.externalID
            );
            return data;
          } catch (error) {
            this.$log('Error fetching trade autocomplete data', error);
            return error;
          }
        },
        keys: ['suggest'],
      },
      resultItem: {
        highlight: true,
      },
      events: {
        input: {
          selection: event => {
            this.autoCompleteInputValInner = event.detail.selection.value.suggest;
            this.autoCompleteSelectedObjectInner = event.detail.selection.value;
          },
          focus() {
            if (autoCompleteJS.input.value.length) autoCompleteJS.start();
          },
        },
      },
    });
  },
};
</script>
